<template>
  <draggable :list="assets" handle=".handle" @end="sortList(true)">
    <transition-group>
      <v-list v-for="(item, index) in assets" :key="item.id" two-line class="text-left">
          <SortCourseMaterialListItem :item="item" :id="id" :index="index" />
        <v-divider v-if="index != assets.length - 1" :key="index"></v-divider>
      </v-list>
    </transition-group>
  </draggable>
</template>
<script>
import courseAPI from "@/api/course.js";
import Draggable from "vuedraggable";
import SortCourseMaterialListItem from "@/components/partner/course/SortCourseMaterialListItem";

export default {
  name: "SortCourseMaterial",
  components: {
    Draggable,
    SortCourseMaterialListItem
  },
  props: {
    assets: {
      type: Array,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  methods: {
    removeAsset(index, id) {
      this.assets.splice(index, 1);
      courseAPI.removeCourseMaterial(this.id, id).then(() => {});
    },
    sortList(andSave) {
      const list = [];
      this.assets.forEach(function(x) {
        list.push(x.id);
      });
      andSave ? this.saveSortOrder(list) : null;
    },
    saveSortOrder(list) {
      courseAPI.updateSort(this.id, list).then(() => {});
    }
  }
};
</script>